import api from './api';

/**
 * Servicio para gestionar permisos
 */
export const permisosService = {
  /**
   * Obtener todos los permisos
   * @param {string} modulo - Filtrar por módulo específico (opcional)
   */
  getAll: async (modulo = null) => {
    const params = {};
    if (modulo) params.modulo = modulo;
    const response = await api.get('/permisos', { params });
    return response;
  },

  /**
   * Obtener un permiso por ID
   * @param {number} id - ID del permiso
   */
  getById: async (id) => {
    const response = await api.get(`/permisos/${id}`);
    return response;
  },

  /**
   * Crear un nuevo permiso
   * @param {object} permiso - Datos del permiso
   */
  create: async (permiso) => {
    const response = await api.post('/permisos', permiso);
    return response;
  },

  /**
   * Actualizar un permiso
   * @param {number} id - ID del permiso
   * @param {object} permiso - Datos actualizados del permiso
   */
  update: async (id, permiso) => {
    const response = await api.put(`/permisos/${id}`, permiso);
    return response;
  },

  /**
   * Desactivar un permiso (baja lógica)
   * @param {number} id - ID del permiso
   */
  delete: async (id) => {
    const response = await api.delete(`/permisos/${id}`);
    return response;
  },
};

